module.exports = __webpack_public_path__ + "lato-bold-webfont.1ad5d422cec6d18fb8cc.woff";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-bold-webfont.woff
// module id = ../../../../../resources/fonts/lato-bold-webfont.woff
// module chunks = styles